import _taggedTemplateLiteral from "@babel/runtime-corejs2/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    mutation updateUserAttribute($id: String!, $value: String!) {\n  updateUserAttribute(input: {id: $id, value: $value}) {\n    userAttribute {\n      ... on AttributeJson {\n        id\n        value\n      }\n    }\n  }\n}\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    query getUserContext($navUiStateKey: String!) {\n  user {\n    id\n    firstName\n    lastName\n    email\n    navUiState: userAttribute(id: $navUiStateKey) {\n      ... on AttributeJson {\n        value\n      }\n    }\n    currentOrganization {\n      id\n      name\n      role\n      products {\n        id\n        name\n        activated\n        productRole\n      }\n    }\n    organizations {\n      id\n      name\n      products {\n        id\n        name\n        activated\n        productRole\n      }\n    }\n  }\n}\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export var OrganizationRole;

(function (OrganizationRole) {
  OrganizationRole["Owner"] = "OWNER";
  OrganizationRole["Admin"] = "ADMIN";
  OrganizationRole["Member"] = "MEMBER";
  OrganizationRole["Billing"] = "BILLING";
  OrganizationRole["RestrictedMember"] = "RESTRICTED_MEMBER";
})(OrganizationRole || (OrganizationRole = {}));

export var ProductRole;

(function (ProductRole) {
  ProductRole["Owner"] = "OWNER";
  ProductRole["Admin"] = "ADMIN";
  ProductRole["Editor"] = "EDITOR";
  ProductRole["Member"] = "MEMBER";
  ProductRole["Viewer"] = "VIEWER";
  ProductRole["ReadOnly"] = "READ_ONLY";
  ProductRole["Contact"] = "CONTACT";
  ProductRole["NoAccess"] = "NO_ACCESS";
  ProductRole["RmAll"] = "RM_ALL";
  ProductRole["RwAll"] = "RW_ALL";
  ProductRole["RoAll"] = "RO_ALL";
  ProductRole["RwFew"] = "RW_FEW";
  ProductRole["RoFew"] = "RO_FEW";
  ProductRole["RmAllPay"] = "RM_ALL_PAY";
  ProductRole["RwAllPay"] = "RW_ALL_PAY";
  ProductRole["RwFewPay"] = "RW_FEW_PAY";
  ProductRole["RoAllPay"] = "RO_ALL_PAY";
  ProductRole["RoFewPay"] = "RO_FEW_PAY";
})(ProductRole || (ProductRole = {}));

export var SamlOrganizationMapping;

(function (SamlOrganizationMapping) {
  SamlOrganizationMapping["Mapping"] = "MAPPING";
})(SamlOrganizationMapping || (SamlOrganizationMapping = {}));

export var GroupMappingType;

(function (GroupMappingType) {
  GroupMappingType["Organization"] = "ORGANIZATION";
  GroupMappingType["Product"] = "PRODUCT";
})(GroupMappingType || (GroupMappingType = {}));

export var Product;

(function (Product) {
  Product["Appoptics"] = "APPOPTICS";
  Product["Loggly"] = "LOGGLY";
  Product["Pingdom"] = "PINGDOM";
  Product["Papertrail"] = "PAPERTRAIL";
})(Product || (Product = {}));

export var LogProduct;

(function (LogProduct) {
  LogProduct["Loggly"] = "LOGGLY";
  LogProduct["Papertrail"] = "PAPERTRAIL";
})(LogProduct || (LogProduct = {}));

export var ProductContext;

(function (ProductContext) {
  ProductContext["Appoptics"] = "APPOPTICS";
  ProductContext["Loggly"] = "LOGGLY";
  ProductContext["Pingdom"] = "PINGDOM";
  ProductContext["Papertrail"] = "PAPERTRAIL";
  ProductContext["InfrastructureMonitor"] = "INFRASTRUCTURE_MONITOR";
})(ProductContext || (ProductContext = {}));

export var AttributeType;

(function (AttributeType) {
  AttributeType["String"] = "STRING";
  AttributeType["Int"] = "INT";
  AttributeType["Float"] = "FLOAT";
  AttributeType["Bool"] = "BOOL";
  AttributeType["Json"] = "JSON";
})(AttributeType || (AttributeType = {}));

export var VolumetricsField;

(function (VolumetricsField) {
  VolumetricsField["Host"] = "HOST";
  VolumetricsField["Tag"] = "TAG";
  VolumetricsField["App"] = "APP";
  VolumetricsField["Pipeline"] = "PIPELINE";
  VolumetricsField["Product"] = "PRODUCT";
})(VolumetricsField || (VolumetricsField = {}));

export var VolumetricsMeasurementType;

(function (VolumetricsMeasurementType) {
  VolumetricsMeasurementType["Count"] = "COUNT";
  VolumetricsMeasurementType["VolumeBytes"] = "VOLUME_BYTES";
})(VolumetricsMeasurementType || (VolumetricsMeasurementType = {}));

export var VolumetricsResolution;

(function (VolumetricsResolution) {
  VolumetricsResolution["Auto"] = "AUTO";
})(VolumetricsResolution || (VolumetricsResolution = {}));

export var ApmSummaryField;

(function (ApmSummaryField) {
  ApmSummaryField["Service"] = "SERVICE";
  ApmSummaryField["Host"] = "HOST";
})(ApmSummaryField || (ApmSummaryField = {}));

export var ApmSummaryMeasurementType;

(function (ApmSummaryMeasurementType) {
  ApmSummaryMeasurementType["CpuUtilization"] = "CPU_UTILIZATION";
  ApmSummaryMeasurementType["MemoryUtilization"] = "MEMORY_UTILIZATION";
  ApmSummaryMeasurementType["ResponseTime"] = "RESPONSE_TIME";
  ApmSummaryMeasurementType["RequestVolume"] = "REQUEST_VOLUME";
  ApmSummaryMeasurementType["ErrorRate"] = "ERROR_RATE";
  ApmSummaryMeasurementType["HostsCount"] = "HOSTS_COUNT";
})(ApmSummaryMeasurementType || (ApmSummaryMeasurementType = {}));

export var OutagesType;

(function (OutagesType) {
  OutagesType["Uptime"] = "UPTIME";
  OutagesType["Transaction"] = "TRANSACTION";
})(OutagesType || (OutagesType = {}));

export var TokenAccessLevel;

(function (TokenAccessLevel) {
  TokenAccessLevel["Record"] = "RECORD";
  TokenAccessLevel["Read"] = "READ";
  TokenAccessLevel["Full"] = "FULL";
})(TokenAccessLevel || (TokenAccessLevel = {}));

export var LogFilterOperator;

(function (LogFilterOperator) {
  LogFilterOperator["Contains"] = "CONTAINS";
  LogFilterOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
})(LogFilterOperator || (LogFilterOperator = {}));

export var LogFilterKind;

(function (LogFilterKind) {
  LogFilterKind["Regex"] = "REGEX";
  LogFilterKind["String"] = "STRING";
})(LogFilterKind || (LogFilterKind = {}));

export var EnclaveType;

(function (EnclaveType) {
  EnclaveType["Angular"] = "ANGULAR";
  EnclaveType["Angularjs"] = "ANGULARJS";
  EnclaveType["Webform"] = "WEBFORM";
  EnclaveType["Swicus"] = "SWICUS";
})(EnclaveType || (EnclaveType = {}));

export var GetUserContextDocument = gql(_templateObject());
/**
 * __useGetUserContextQuery__
 *
 * To run a query within a React component, call `useGetUserContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContextQuery({
 *   variables: {
 *      navUiStateKey: // value for 'navUiStateKey'
 *   },
 * });
 */

export function useGetUserContextQuery(baseOptions) {
  return Apollo.useQuery(GetUserContextDocument, baseOptions);
}
export function useGetUserContextLazyQuery(baseOptions) {
  return Apollo.useLazyQuery(GetUserContextDocument, baseOptions);
}
export var UpdateUserAttributeDocument = gql(_templateObject2());

/**
 * __useUpdateUserAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateUserAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAttributeMutation, { data, loading, error }] = useUpdateUserAttributeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateUserAttributeMutation(baseOptions) {
  return Apollo.useMutation(UpdateUserAttributeDocument, baseOptions);
}